import { Heading, Text, Box } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export const ProfileDataRow = ({
  label,
  message,
  leftEl,
  ...restProps
}: {
  label?: string;
  message?: string;
  leftEl?: ReactNode;
  [key: string]: any;
}) => {
  const {t} = useTranslation();

  return (
    <Box {...restProps}>
      <Heading variant='label'>{label}</Heading>
      <Text color={message ? 'initial' : 'blackAlpha.500'}>
        {leftEl}
        {message || t('no.data')}
      </Text>
    </Box>
  );
};
